import { ActionTree } from 'vuex';
import { ClaimState } from './types';
import { RootState } from '@/types';
import { claimService } from '@/services/claim.services';


export const actions: ActionTree<ClaimState, RootState> = {
    get({ dispatch }, { id = '' }): any {
        dispatch('getClaim', { id });
        dispatch('getComments', { id });
        dispatch('getAttachments', { id });
        dispatch('getPayments', { id });
        dispatch('getReminders', { id });
    },
    getClaim({ commit }, { id = '' }): any {
        commit('setLoading');
        claimService.show(id)
        .then((response) => {
            const payload: any = response && response.data;
            commit('setData', payload);
        }, (error) => {
            commit('setError', error);
        });
    },
    getComments({ commit }, { id = '', page = 1, perPage = 10}): any {
        commit('setCommentsLoading');
        claimService.getComments(id, page, perPage)
        .then((response) => {
            const payload: any = response && response.data;
            commit('setCommentsData', payload);
        }, (error) => {
            commit('setCommentsError', error);
        });
    },
    getPayments({ commit }, { id = ''}): any {
        commit('setPaymentsLoading');
        claimService.getPayments(id)
        .then((response) => {
            const payload: any = response && response.data;
            commit('setPaymentsData', payload);
        }, (error) => {
            commit('setPaymentsError', error);
        });
    },
    getReminders({ commit }, { id = ''}): any {
        commit('setRemindersLoading');
        claimService.getReminders(id)
        .then((response) => {
            const payload: any = response && response.data;
            commit('setRemindersData', payload);
        }, (error) => {
            commit('setRemindersError', error);
        });
    },
    postComment({ dispatch }, {
        id,
        comment,
        page = 1,
        perPage = 10,
    }): any {
        let post;
        if (comment.id) {
            post = claimService.putComment(comment.id, comment);
        } else {
            post = claimService.postComments(id, comment);
        }
        post.then((response) => {
            const commentId: string = response && response.data && response.data.id;
            if (comment.attachments && comment.attachments.length > 0) {
                for (const attachment of comment.attachments) {
                    if (attachment instanceof File) {
                        claimService.postAttachment(commentId, attachment)
                            .then(() => {
                                dispatch('getComments', {id, page, perPage});
                                dispatch('getAttachments', {id});
                                dispatch('getPayments', {id});
                                dispatch('getReminders', {id});
                            });
                    } else {
                        dispatch('getComments', {id, page, perPage});
                        dispatch('getPayments', {id});
                        dispatch('getReminders', {id});
                    }
                }
            } else {
                dispatch('getComments', { id, page, perPage });
                dispatch('getPayments', { id });
                dispatch('getReminders', { id });
            }
        });
    },
    getAttachments({ commit }, { id = ''}): any {
        commit('setAttachmentsLoading');
        claimService.getAttachments(id)
        .then((response) => {
            const payload: any = response && response.data;
            commit('setAttachmentsData', payload);
        }, (error) => {
            commit('setAttachmentsError', error);
        });
    },
    getInterests({ commit }, { id = ''}): any {
        commit('setInterestsLoading');
        claimService.calculateInterests(id)
        .then((response) => {
            const payload: any = response && response.data;
            commit('setInterestsData', payload);
        }, (error) => {
            commit('setInterestsError', error);
        });
    },
};
